export default __webpack_public_path__ + "static/media/RESUME.e3530aec.pdf";